module.exports = __webpack_public_path__ + "static/ENmobSlide8-ff39c5a9abac8e9e18de94ed1473a3e6.jpg";